{
  "chatAlsoDriverQuestion": "Você também dirige os veículos da sua frota?",
  "chatAlsoDriverHint": "Você pode completar seu perfil de motorista depois do cadastro.",
  "chatAlsoDriverYes": "Sim, também dirijo",
  "chatAlsoDriverNo": "Não, apenas gerencio a frota",
  "chatEmailQuestion": "Qual é o seu email?",
  "chatEmailHint": "Você vai usá-lo para entrar na sua conta.",
  "chatPasswordQuestion": "Crie uma senha",
  "chatPasswordHint": "Pelo menos 8 caracteres.",
  "chatNameQuestion": "Qual é o seu nome?",
  "chatPhoneQuestion": "Qual é o seu celular?",
  "chatPhoneHint": "Para contatos sobre a sua frota.",
  "chatOwnerTypeQuestion": "Como você opera a sua atividade?",
  "chatOwnerTypeHint": "Escolha a opção que corresponde à sua situação.",
  "chatNifQuestion": "Qual é o seu NIF?",
  "chatAddressQuestion": "Qual é o seu endereço?",
  "chatCmtvdeQuestion": "Qual é o seu CMTVDE?",
  "chatDobQuestion": "Qual é a sua data de nascimento?",
  "chatDobHint": "Use o formato DD/MM/AAAA.",
  "chatCompanyNameQuestion": "Qual é o nome da empresa?",
  "chatNipcQuestion": "Qual é o NIPC da empresa?",
  "chatLicenseQuestion": "Qual é a licença de operador?",
  "chatLicenseHint": "Formato: número/ano — por exemplo 12345/2024.",
  "chatContinue": "Continuar",
  "chatProgress": "{{current}}/{{total}}",
  "ownerTypeIndividual": "Autônomo / NIF",
  "ownerTypeCompany": "Empresa / NIPC",
  "nifLabel": "NIF",
  "nifPlaceholder": "NIF",
  "nifRequired": "O NIF é obrigatório.",
  "nifInvalidLength": "NIF deve ter 9 dígitos",
  "nifInvalid": "NIF inválido",
  "addressPlaceholder": "Endereço",
  "addressRequired": "O endereço é obrigatório.",
  "cmtvdePlaceholder": "Número da CMTVDE",
  "cmtvdeRequired": "O CMTVDE é obrigatório.",
  "cmtvdeInvalid": "Formato inválido (N+/YYYY).",
  "dobPlaceholder": "Data de nascimento",
  "dateOfBirthRequired": "A data de nascimento é obrigatória.",
  "registerTitle": "Cadastrar",
  "chooseRolePrompt": "Escolha como deseja registar-se: Condutor ou Proprietário de Frota. Se for ambos, registe-se como Proprietário.",
  "driverButton": "Condutor",
  "ownerButton": "Proprietário de Frota",
  "registerDriverTitle": "Registo de Condutor",
  "registerOwnerTitle": "Registar como Proprietário de Frota",
  "loginInformation": "Informações de Login",
  "identification": "Identificação",
  "driverDetails": "Detalhes do Condutor",
  "companyInformation": "Informação da Empresa",
  "next": "Próximo",
  "back": "Voltar",
  "submitButton": "Enviar",
  "registrationSuccessTitle": "Registado com sucesso!",
  "registrationSuccessMessage": "Confirme o seu email para completar o registo.",
  "okButton": "OK",
  "ownerButtonDisabled": "Registo de Proprietário Desativado",
  "driverButtonDisabled": "Registo de Condutor Desativado",
  "loadingRegistrationStatus": "A carregar opções de registo...",
  "continue": "Continuar",
  "employmentTitle": "Informações de Emprego",
  "loadingEmploymentInfo": "Carregando informações de emprego...",
  "employmentDataFound": "Encontramos suas informações de emprego:",
  "edit": "Editar",
  "retry": "Tentar Novamente",
  "employmentFormIntro": "Por favor, forneça suas informações de emprego:",
  "companyName": "Nome da Empresa",
  "companyNameRequired": "O nome da empresa é obrigatório.",
  "companyNipc": "NIF/NIPC da Empresa",
  "nipcError": "O NIF/NIPC deve conter 9 dígitos",
  "nipcInvalid": "NIPC inválido",
  "companyEmail": "Email da Empresa",
  "companyPhone": "Telefone da Empresa",
  "companyEmailOptional": "Email da empresa (opcional)",
  "companyPhoneOptional": "Telefone da empresa (opcional)",
  "companyContactOr": "OU",
  "permissionsTitle": "Permissões do Aplicativo",
  "permissionsDescription": "Para fornecer a melhor experiência, precisamos das seguintes permissões:",
  "notificationsPermissionTitle": "Notificações",
  "notificationsPermissionDescription": "Para receber alertas e informações importantes",
  "locationForegroundPermissionTitle": "Localização (Primeiro Plano)",
  "locationForegroundPermissionDescription": "Para mostrar sua localização atual no mapa",
  "locationBackgroundPermissionTitle": "Localização (Segundo Plano)",
  "locationBackgroundPermissionDescription": "Para continuar rastreando mesmo quando o aplicativo está fechado",
  "locationBackgroundPermissionImportant": "Importante: Para receber notificações quando estiver parado no mesmo local durante algum tempo, você precisa selecionar 'Permitir sempre' nas configurações de localização do seu dispositivo.",
  "permissionsFinish": "Concluir",
  "duplicateIdentityTitle": "Já está cadastrado",
  "duplicateIdentityMessage": "Esse dado já está cadastrado em uma conta existente. Faça login com essa conta em vez de criar um novo cadastro.",
  "goToLogin": "Entrar na conta",
  "recoverAccount": "Recuperar acesso",
  "requestAuthorizedClaim": "Pedir ajuda ao suporte",
  "supportRequestTitle": "Pedir ajuda ao suporte",
  "supportRequestIntro": "Informe um contato e explique brevemente como podemos ajudar. A equipe de suporte poderá pedir documentos mais tarde por um canal autenticado.",
  "supportRequestEmail": "Email",
  "supportRequestPhone": "Celular",
  "supportRequestDescription": "Como podemos ajudar?",
  "supportRequestSubmit": "Enviar pedido",
  "supportRequestReceived": "Recebemos seu pedido. A equipe de suporte entrará em contato.",
  "supportRequestFailed": "Não foi possível enviar o pedido. Tente novamente.",
  "supportRequestPhoneRequired": "Informe seu celular.",
  "supportRequestEmailRequired": "Informe seu email.",
  "supportRequestDescriptionRequired": "Descreva brevemente o pedido.",
  "supportAccountTitle": "Criar sua conta de suporte",
  "supportAccountIntro": "Crie e confirme sua conta para que a equipe continue analisando o pedido. Você não precisa informar o NIPC novamente.",
  "supportAccountName": "Nome completo",
  "supportAccountPassword": "Senha",
  "supportAccountRequired": "Preencha todos os campos para continuar.",
  "supportAccountSubmit": "Criar conta",
  "supportAccountCreated": "Conta criada. Confirme seu email para a equipe de suporte continuar.",
  "supportAccountFailed": "Não foi possível criar a conta. Tente novamente.",
  "cancel": "Cancelar",
  "chatGreeting": "Olá! 👋 Bem-vindo ao AllDrivers.",
  "chatChoiceQuestion": "Para começar: você gerencia uma frota ou dirige?",
  "chatChoiceHint": "Leva menos de 2 minutos — prometido.",
  "chatChoiceOwner": "Tenho uma frota 🚗",
  "chatChoiceOwnerAnswer": "Tenho uma frota 🚗",
  "chatChoiceDriver": "Sou motorista 🧑‍✈️",
  "chatChoiceDriverAnswer": "Sou motorista 🧑‍✈️",
  "chatOwnerIntro": "Ótimo! Vamos criar a sua conta de frota. 🚗",
  "chatAccountCreatedBridge": "Conta criada! 🎉 Agora vamos preparar a sua frota.",
  "chatDriverIntro": "Vamos criar a sua conta de motorista. 🧑‍✈️",
  "chatProfileRecoveryIntro": "Vamos completar os dados da sua conta. 🧑‍✈️",
  "chatDriverPhoneHint": "Para contatos sobre a sua atividade.",
  "chatPayerQuestion": "Quem paga a sua licença?",
  "chatPayerHint": "Você pode mudar isso depois.",
  "chatCompanyQuestion": "A que empresa está associado?",
  "chatCompanyHint": "Buscamos a empresa pelo NIPC. Se a encontrarmos, não precisa informar contato.",
  "companyLookupFoundTitle": "Encontramos esta empresa",
  "companyLookupFoundMessage": "{{name}} (NIPC {{nipc}}). É esta a empresa para a qual trabalha?",
  "companyLookupConfirmYes": "Sim, é a minha empresa",
  "companyLookupConfirmNo": "Não, vou corrigir",
  "companyLookupConfirmRequired": "Confirme se é esta a empresa para a qual trabalha.",
  "companyLookupInviteMismatch": "O NIPC não corresponde à empresa do convite. Corrija antes de continuar.",
  "companyLookupConfirmedHint": "Empresa confirmada. Pode continuar.",
  "companyLookupLoading": "Verificando empresa…",
  "companyLookupFailed": "Não foi possível verificar a empresa.",
  "companyContactHintUnknown": "Não encontramos esta empresa. Preencha apenas um dos dois campos: email ou telefone.",
  "companyContactRequired": "Informe um email ou telefone da empresa — não conseguimos encontrar esta empresa.",
  "payerRequired": "Escolha quem paga.",
  "payerCompany": "Minha empresa paga",
  "payerSelf": "Eu pago a minha licença",
  "chatProductQuestion": "O que você quer usar?",
  "chatProductHint": "Escolha um; outras combinações ficam no painel.",
  "productRequired": "Escolha um produto.",
  "productOptionHours": "Registro de horas",
  "productOptionGps": "GPS",
  "productOptionCombo": "Horas + GPS",
  "companyContactRequired": "Informe um email ou telefone da empresa.",
  "invitationFoundTitle": "Encontramos um convite",
  "invitationFoundMessage": "{{company}} já convidou este email. Quer aceitar o convite?",
  "invitationFoundDecline": "Continuar sem convite",
  "invitationFoundAccept": "Aceitar convite",
  "invitationLinkRequiredTitle": "Use o link do convite",
  "invitationLinkRequiredMessage": "Existe um convite para este email. Abra o link recebido para continuar; não mostramos os detalhes do convite aqui.",
  "outcomeC4Title": "Ainda não encontramos essa empresa",
  "outcomeC4Message": "{{company}} ainda não está no AllDrivers. Já enviamos um convite ao contato que você indicou — você também pode compartilhar o link diretamente.",
  "outcomeC3Title": "Aguardando aprovação",
  "outcomeC3Message": "{{company}} já está no AllDrivers — avisamos o gestor. Assim que aprovar, seu acesso fica ativo.",
  "outcomeActiveTitle": "Tudo pronto",
  "outcomeActiveMessage": "Seu vínculo com {{company}} está ativo. Você já pode começar a trabalhar.",
  "outcomePendingInviteTitle": "Aguardando ativação",
  "outcomePendingInviteMessage": "Sua conta está aguardando ativação.",
  "outcomePendingLicenseTitle": "Aguardando ativação",
  "outcomePendingLicenseMessage": "Sua conta está aguardando ativação.",
  "outcomeContactTitle": "Ainda não encontramos essa empresa",
  "outcomeContactMessage": "{{company}} ainda não está no AllDrivers. Guardamos seu contato e nossa equipe vai falar com a empresa — você também pode compartilhar o link diretamente com o gestor.",
  "outcomeFailedTitle": "Não foi possível concluir",
  "outcomeFailedMessage": "Algo deu errado ao concluir seu cadastro com {{company}}. Tente novamente ou fale com o suporte.",
  "outcomeSelfPayHint": "Quando a empresa aprovar, volte em Configurações → Pagar minha licença para ativar o pagamento próprio.",
  "outcomeShareCta": "Compartilhar com o gestor",
  "outcomeContinue": "Ir para o Dashboard",
  "outcomeContactContinue": "Acompanhar ativação",
  "companyContactPendingTitle": "Aguardando a empresa",
  "companyContactPendingBody": "A empresa ainda não ativou seu acesso. Você pode esperar pela empresa ou pagar sua própria licença para seguir agora.",
  "companyContactPendingSelfPayTitle": "Seguir sem esperar",
  "companyContactPendingSelfPayBody": "Se escolheu a empresa por engano ou não quer mais esperar, mude para pagamento próprio. Você só paga depois de escolher e confirmar o plano.",
  "companyContactPendingSelfPay": "Pagar minha própria licença",
  "companyContactPendingSelfPayError": "Não foi possível mudar para pagamento próprio. Tente novamente.",
  "companyContactPendingWaitTitle": "Continuar esperando",
  "companyContactPendingWaitBody": "Compartilhe este link com o gestor para acelerar a ativação.",
  "companyContactPendingShare": "Compartilhar link com o gestor",
  "companyContactPendingLogout": "Sair",
  "captchaError": "Não foi possível confirmar que você é uma pessoa. Tente novamente.",
  "captchaFailed": "A verificação falhou. Tente novamente.",
  "appStoresTitle": "Instale o app AllDrivers",
  "appStoresMessage": "Instale o app e entre com a mesma conta AllDrivers. Não crie outra conta. Se ainda não confirmou o e-mail, confirme primeiro pela mensagem de cadastro.",
  "downloadApp": "Baixar o app",
  "appStoreOpenError": "Não foi possível abrir a loja. Tente novamente no botão da loja.",
  "appStoreTrademarks": "Apple, o logotipo Apple e App Store são marcas da Apple Inc. Google Play e o logotipo Google Play são marcas da Google LLC.",
  "appStoreAndroid": "Google Play (Android)",
  "appStoreIos": "App Store (iPhone)",
  "appLandingTitle": "Comece com a AllDrivers",
  "appLandingRegisterNow": "Cadastrar agora",
  "appLandingManualCode": "Cadastre-se aqui ou instale o app. Guarde o código para informar no cadastro: a instalação pela loja não garante que o código seja preservado.",
  "appLandingChecking": "Verificando o código de indicação…",
  "appLandingInvalid": "Este código não está disponível para novas indicações. Você pode fazer um cadastro comum sem indicação.",
  "appLandingUnavailable": "Não foi possível verificar o código agora. Tente novamente ou escolha cadastrar-se sem indicação.",
  "appLandingWithoutWarning": "Se concluir o cadastro sem indicação, não poderá adicioná-la depois.",
  "appLandingWithout": "Cadastrar sem indicação",
  "appLandingMessageAndroid": "Instale o app pelo Google Play. O código de indicação acompanha a instalação e já vem preenchido quando você se cadastrar no app.",
  "appLandingMessageIos": "Instale o app pela App Store. Depois de instalar, volte a esta página e toque em “Já tenho o app — abrir no app” para manter o código de indicação.",
  "appLandingStoresTitle": "Instalar o app",
  "appLandingStoresMessage": "Escolha a loja do seu celular.",
  "appLandingCodeLabel": "Seu código de indicação",
  "appLandingCodeHelp": "Guarde este código. Se o app não o mostrar no cadastro, volte a esta página e abra o app pelo botão abaixo.",
  "appLandingCopy": "Copiar código",
  "appLandingCopied": "Código copiado.",
  "appLandingCopyFailed": "Não foi possível copiar. Anote o código acima.",
  "appLandingOpenApp": "Já tenho o app — abrir no app",
  "appLandingContinueWeb": "Continuar no navegador"
}
